<template>
  <div class="page-container">
    <!-- <el-breadcrumb>
      <el-breadcrumb-item>内部转账</el-breadcrumb-item>
    </el-breadcrumb> -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">其他功能</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>统计报表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <!-- <create @refresh="getList"></create> -->
        <!-- <el-input size="small" placeholder="搜索交易对" clearable v-model="symbol">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input> -->
        <el-select size="small" clearable v-model="symbol" filterable placeholder="请选择">
          <el-option
            v-for="item in symbolData"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
        <el-tooltip placement="top">
        <div slot="content">底部表格统计时交易对必须选择，<br/>否则表格无法生成数据</div>
        <el-button type="info" size="small" circle >
          <i class="el-icon-warning-outline" ></i>
        </el-button>
        </el-tooltip>

        <el-select style="width: 300px;" size="small" clearable v-model="type" filterable placeholder="请选择type">
          <el-option
            v-for="item in typeData"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>

        <el-date-picker
        size="small"
          v-model="value2"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions">
        </el-date-picker>


        <el-tooltip placement="top">
        <div slot="content">查询起始时间为‘开始日期’UTC-0 00:00:00，<br/>结束时间为‘结束日期’ UTC-0 23:59:59<br/>如果时间选项为空，默认为当天0点至24点</div>
        <el-button type="info" size="small" circle >
          <i class="el-icon-warning-outline" ></i>
        </el-button>
        </el-tooltip>
        <el-button size="small" @click="handleSearch" type="primary">搜索</el-button>
        <el-tooltip class="item" effect="dark" content="导出Excel必须选择时间段" placement="top">
          <el-button size="small" @click="handleExport" type="primary">导出Excel</el-button>
        </el-tooltip>
        
      </div>
      <br/>
      <list @refresh="getList" :startTime="startTime" :endTime="endTime" :symbol="symbol" :type="type"></list>

      <!-- 查询起始时间为‘开始日期’UTC-0 00:00:00，结束时间为‘结束日期’ UTC-0 23:59:59 -->
      <!-- <div class="userContent">
          <span class="rank">排行榜</span>
        <div>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="总排行" name="first">
              <Rank :activeLabel="activeLabel" :startTime="startTime" :endTime="endTime"></Rank>
            </el-tab-pane>
            <el-tab-pane label="今日" name="second">
              <Rank :activeLabel="activeLabel" :startTime="startTime" :endTime="endTime"></Rank>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div> -->
      <div class="columnData">
        <CloumnLine :startTime="startTime" :endTime="endTime" :symbol="symbol" :type="type"></CloumnLine>
      </div>
      <div class="columnData">
        <Statical :startTime="startTime" :endTime="endTime" :symbol="symbol" :type="type"></Statical>
      </div>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import List from './components/list';
import Create from './components/create';
import Rank from './components/rank'
import CloumnLine from './components/cloumnLine'
import Statical from './components/statical'
import moment from 'moment';


export default {
  name: 'Report',
  data() {
    return {
      symbol: '',
      activeName: 'first',
      activeLabel:'',
      pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        value1: '',
        value2: [
          new Date(new Date().setHours(0, 0, 0, 0)).getTime(),
        new Date(new Date().setHours(23, 59, 59, 999)).getTime()
      ],
        startTime:0,
        endTime:0,
        type:'',
        typeData:[
          {label:'传入交易对和时间，导出当交易对',value:0},
          {label:'传入时间，导出所有交易对，按时间，新增',value:1},
          {label:'传入时间，导出所有交易对，按交易对分组',value:2},
        ]
    };
  },
  components: {
    List,Rank,
    Create,CloumnLine,Statical
  },
  computed: {
    ...mapState('report', ['pagination','symbolData']),
    ...mapGetters('report', ['list'])
  },
  methods: {
    ...mapActions('report', ['reqList', 'getCoinTypes','getTurnover','getAllSymbol','getTranscation','exportExcel','getStaticalChart','getTotalStatical']),
    handleSearch() {
      console.log((new Date()).valueOf(),'-------------',this.value2);
      // this.reqList({ page: 1,size:25, userId: this.userId, });
      
      if(this.value2!=null){
      //   console.log(this.value2[0].valueOf());
      // console.log(this.value2[1].valueOf());
        this.startTime=this.value2[0].valueOf() 
      this.endTime=this.value2[1].valueOf() 
      }else{ 
        this.startTime=new Date(new Date().setHours(0, 0, 0, 0)).getTime()   //当天0点的时间戳
        this.endTime=new Date(new Date().setHours(23, 59, 59, 999)).getTime()  //当天24点的时间戳
        // console.log('start',this.startTime);
        // console.log('end',this.endTime);
      }
      
      this.getTurnover({
            endTime:this.endTime ,
            startTime: this.startTime,
            symbol: this.symbol,
            type: this.type
      })
      this.getTranscation({
            endTime: this.endTime,
            startTime: this.startTime,
            symbol: this.symbol,
            type: this.type
      })
      // this.getTotalStatical({
      //   endTime: this.endTime,
      //       startTime: this.startTime,
      //       symbol: this.symbol,
      //       type: this.type,
      //       page:1,size:25
      // })
      if(this.symbol && this.value2.length!=0){
        this.getStaticalChart({
        startTime: this.startTime,
        endTime: this.endTime,
            symbol: this.symbol,
            type: this.type,
          page:1,size:25
          })
      }
     
    },
    handleExport(){
      console.log(this.value2[0].valueOf());
      this.exportExcel({
        endTime: this.value2[1].valueOf(),
        startTime: this.value2[0].valueOf(),
        symbol: this.symbol,
        type: this.type
      }).then(res=>{
   
        const link=document.createElement('a') 
      const blob = new Blob([res], { type: 'application/vnd.ms-excel' }) //设置文件流
      link.style.display = 'none'
      // 设置连接
      link.href = URL.createObjectURL(blob)  //将文件流转化为blob地址
      console.log('link-href',link.href);
      link.download = '统计报表'
      document.body.appendChild(link)
      // 模拟点击事件
      link.click()  //设置点击事件
      })
    },
    handleClick(tab, event) {
        console.log(tab.label, event);
        if(tab.label=='今日'){
          this.activeLabel=tab.label
        }else{
          this.activeLabel=''
        }
      },
    getList(data = {}) {
      this.getTurnover({
            endTime: this.startTime,
            startTime: this.endTime,
            symbol: this.symbol,
            type: this.type
      })
    }
  },
  created() {
    // this.getCoinTypes();
    // this.getList();
    this.getAllSymbol({buyCoin:'',page:1,size:100,symbol:'',state:''})
   
  }
};
</script>

<style lang="less" scoped>
.actions-bar {
  display: flex;
  align-items: center;
}

.el-input {
  width: 300px;
}

.el-date-editor,
.el-input {
  margin-right: 10px;
}
.userContent{
  margin-top: 10px;
  width: 100%;
  // border: 1px solid tomato;
  height: 500px;
  padding: 10px;
  box-sizing: border-box;
  .rank{
    font-size: 20px;
    display: block;
    margin-bottom: 10px;
  }
}
.columnData{
  box-sizing: border-box;
  width: 100%;
  // height: 300px;
  // border: 1px solid gray;
  padding: 10px;
}
</style>
